import { Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { EstimateInput, NameInput } from '../VehicleFields';

const useStyles = makeStyles()((theme) => ({
  mainTitle: {
    marginBottom: theme.spacing(2),
  },
}));

export const ManualStep = () => {
  const { classes } = useStyles();

  return (
    <>
      <Typography variant='headlineRegular' className={classes.mainTitle}>
        Fill in your automobile&apos;s details.
      </Typography>
      <NameInput />
      <EstimateInput />
    </>
  );
};
